import React, { useState } from 'react';
import { APP_BASE_URL } from '../../config';
import { formatTimeAgo, formatExactDate } from '@utils/timeUtils';
import UserAvatar from '@uiElements/UserAvatar';

const HistoryItem = ({ item }) => {
  const {
    col,
    old_val,
    new_val,
    old_desc,
    new_desc,
    old_date,
    new_date,
    action_type,
    name,
    activity_date,
    description,
    user_id,
    photo,
  } = item;

  /** ---------- FIX #1: Safe value handling ---------- **/
  const safeValue = (v) => (v === null || v === undefined || v === '' ? '' : String(v).trim());

  const oldDisplay = safeValue(old_desc || old_val);
  const newDisplay = safeValue(new_desc || new_val);

  const hasOld = oldDisplay.length > 0;
  const hasNew = newDisplay.length > 0;

  /** ---------- FIX #2: Long text detection ---------- **/
  const isLongText =
    ['remark', 'notes', 'description'].includes(col) ||
    (old_desc && old_desc.length > 150) ||
    (new_desc && new_desc.length > 150);

  const formattedCol = col?.replace(/_/g, ' ') || '';

  const [showFull, setShowFull] = useState(false);
  const toggleHtml = () => setShowFull((prev) => !prev);

  const avatar = photo
    ? `${APP_BASE_URL}/uploads/profilephoto/${user_id}/profilePic/${photo}`
    : null;

  /** ---------- FIX #3: Updated change formatter ---------- **/
  const formattedChange = () => {
  /** CASE 0 — Created */
  if (action_type === "created") {
    return (
      <div className="text-sm text-gray-700">
        <strong className="capitalize">
          {col || formattedCol}
        </strong>{" "}
        created
      </div>
    );
  }

  /** CASE: Long Text Fields */
  if (isLongText) {
    return (
      <>
        <div className="text-gray-500 text-xs mb-1 capitalize">
          {formattedCol} changed
        </div>

        <div
          className="prose prose-sm max-w-none bg-gray-50 rounded px-3 py-2 border"
          dangerouslySetInnerHTML={{
            __html: showFull
              ? new_desc
              : (new_desc || "").slice(0, 120) +
                (new_desc?.length > 120 ? "..." : ""),
          }}
        />

        {new_desc?.length > 120 && (
          <button
            className="text-xs text-blue-600 mt-1 hover:underline"
            onClick={toggleHtml}
          >
            {showFull ? "Show less" : "Show more"}
          </button>
        )}
      </>
    );
  }

  /** CASE: Normal Change */
  return (
    <div>
      <span className="text-sm text-gray-700">
        <strong className="capitalize">{formattedCol}</strong>{" "}

        {/* Old + New → changed */}
        {hasOld && hasNew && (
          <>
            changed from{" "}
            <span className="text-red-600 font-medium">{oldDisplay}</span>{" "}
            to{" "}
            <span className="text-green-600 font-medium">{newDisplay}</span>
          </>
        )}

        {/* Old exists, new empty → removed */}
        {hasOld && !hasNew && (
          <>
            removed{" "}
            <span className="text-red-600 font-medium">{oldDisplay}</span>
          </>
        )}

        {/* New exists, old empty → set */}
        {!hasOld && hasNew && (
          <>
            set{" "}
            <span className="text-green-600 font-medium">{newDisplay}</span>
          </>
        )}
      </span>
    </div>
  );
};


  return (
    <div className="flex items-start gap-3 mb-6 relative">
      {/* Vertical Timeline Line */}
      <div className="w-10 flex justify-center relative">
        <div className="absolute top-0 bottom-0 left-1/2 border-l-2 border-gray-200 transform -translate-x-1/2" />

        <UserAvatar
        className="mt-1 relative group"
          name={name}
          imageUrl={avatar}
          size={32}
        />
      </div>

      {/* Right Content */}
      <div className="flex-1">
        {formattedChange()}

        <div className="text-xs text-gray-500 mt-1 flex items-center gap-2">
          <span>
            By <strong>{name}</strong>
          </span>

          <span title={formatExactDate(activity_date)}>
            {formatTimeAgo(activity_date)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default HistoryItem;
